import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SessionState, SetSession } from './session';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  static readonly AUTHORIZATION_HEADER = 'Authorization';
  static readonly UPDATE_SESSION_HEADER = 'Update-Session';

  static getProvider(): Provider {
    return {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    };
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.store.selectSnapshot(SessionState.isSignedIn)) {
      request = request.clone({
        headers: request.headers.append(AuthInterceptor.AUTHORIZATION_HEADER, `Bearer ${this.store.selectSnapshot(SessionState.token)}`)
      });
    }

    return next.handle(request).pipe(
      tap({
        next: event => this.respectUpdateSessionHeader(event),
        error: event => this.respectUpdateSessionHeader(event)
      })
    );
  }

  private respectUpdateSessionHeader(event: unknown): void {
    if (!(event instanceof HttpResponse) && !(event instanceof HttpErrorResponse)) {
      return;
    }

    const updateSessionHeader = event.headers.get(AuthInterceptor.UPDATE_SESSION_HEADER);
    if (updateSessionHeader === null) {
      return;
    }

    try {
      const session = JSON.parse(updateSessionHeader);
      this.store.dispatch(new SetSession(session));
    } catch (e) {
      console.error('Failed to update session as specified by Update-Session header.', e);
    }
  }
}
